import {
    Button,
    CircularProgress,
    Grid /* Typography */,
    Modal,
    Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import ModalColocacion from './modalColocacion';
import { sendRequest } from '../../../../services/request';
import { DataGrid, esES, useGridApiRef } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import DataGridTotalFooterColocacion from '../../../../components/utils-components/DataGrid/DataGridTotalFooter/DataGridTotalFooterColocacion';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import 'dayjs/locale/es';
import ModalDiario from './Diario/modalDiario';
import { PreReporteDiario } from './Diario';
import { DataGridStyle } from '../../../../styles/DataGridSytle';
import { ReportGmailerrorred } from '@mui/icons-material';
import { formatterCOP, formatterPTY } from '../../../../utils/utils';

dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.updateLocale('es', {
    months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
        '_',
    ),
    monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split('_'),
    weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split('_'),
});

const PreReportes = ({ pais }) => {
    const URL = process.env.REACT_APP_API_URL;
    const [divisiones, setDivisiones] = useState([]);
    const [reporteDataSemanal, setReporteDataSemanal] = useState(null);
    const [reporteDataDiario, setReporteDataDiario] = useState(null);
    const [columns, setColumns] = useState([]);
    const [totalesFooter, setTotalesFooter] = useState({
        totales: {},
    });
    const [campanaSelected, setCampanaSelected] = useState(null);
    const [divisionSelected, setDivisionSelected] = useState(null);
    const [tipoSelected, setTipoSelected] = useState(null);

    // Week Picker
    const [fecha, setFecha] = useState(null);
    const [hoveredDay, setHoveredDay] = useState(null);

    //Modales
    const [open, setOpen] = useState(false);
    const [openPreReporteColocacion, setOpenPreReporteColocacion] =
        useState(false);
    const [openPreReporteDiario, setOpenPreReporteDiario] = useState(false);

    const [loading, setLoading] = useState(false);
    const [isButtonSelected, setIsButtonSelected] = useState({
        diario: false,
        semanal: false,
    });

    const dataGridRef = useGridApiRef();

    let weekDays = [
        dayjs(fecha).locale('es').weekday(0),
        dayjs(fecha).locale('es').weekday(1),
        dayjs(fecha).locale('es').weekday(2),
        dayjs(fecha).locale('es').weekday(3),
        dayjs(fecha).locale('es').weekday(4),
        dayjs(fecha).locale('es').weekday(5),
        dayjs(fecha).locale('es').weekday(6),
    ];

    // Los pongo con la primera en mayúscula
    const weekDaysName = weekDays.map((day) => {
        day =
            day.format('dddd DD').charAt(0).toUpperCase() +
            day.format('dddd DD').slice(1);
        return day;
    });

    const weekMonthsName = weekDays.map((day) => {
        day =
            day.format('MMM DD').charAt(0).toUpperCase() +
            day.format('MMM DD').slice(1);
        return day;
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await sendRequest('get', `${URL}/${pais}/division`);
                setDivisiones(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, [URL, pais]);

    const handleColocacionSemanal = () => {
        setOpen(true);
        setOpenPreReporteColocacion(true);
        setIsButtonSelected({
            semanal: true,
            diario: false,
        });
    };

    const handlePrereporteDiario = () => {
        setOpen(true);
        setOpenPreReporteDiario(true);
        setIsButtonSelected({
            diario: true,
            semanal: false,
        });
    };

    const handleClose = () => {
        setOpen(false);
        setOpenPreReporteDiario(false);
        setOpenPreReporteColocacion(false);
    };

    const handleContinuar = async (reporteType, dataReporte) => {
        setLoading(true);
        const { tipo, fecha, campana, division } = dataReporte;
        setDivisionSelected(division);
        setTipoSelected(tipo);
        let columns = [
            {
                field: 'first_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[0]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    // Envios es si llega desde Colombia si no EnviosPanama
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 1) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_first_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    // Envios es si llega desde Colombia si no EnviosPanama
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 1) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'second_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[1]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 2) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_second_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 2) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'third_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[2]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 3) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_third_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 3) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'fourth_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[3]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 4) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_fourth_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 4) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'fifth_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[4]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 5) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_fifth_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 5) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'sixth_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[5]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 6) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_sixth_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 6) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'seventh_day',
                headerName:
                    division.id === 1 ? `${weekDaysName[6]}` : 'Donante(s)',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 0) {
                            cantidad += envio.cantidad;
                        }
                    }
                    return cantidad;
                },
            },
            {
                field: 'donacion_seventh_day',
                headerName: 'Recaudado',
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        if (dayjs(envio.created_at).day() === 7) {
                            donacion += envio.donacion_total;
                        }
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
            {
                field: 'total_semana',
                renderHeader: () => {
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            {division.id === 1
                                ? 'Producción Venta'
                                : 'Total Donantes'}
                        </Typography>
                    );
                },
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                align: 'center',
                sortable: false,
                renderCell: ({ row }) => {
                    let cantidad = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        cantidad += envio.cantidad;
                    }
                    return <b>{cantidad}</b>;
                },
            },
            {
                field: 'donacion_total_semana',
                renderHeader: () => {
                    return (
                        <Typography fontWeight="bold" variant="body1">
                            Total Recaudado
                        </Typography>
                    );
                },
                flex: 0.5,
                headerClassName: 'header',
                headerAlign: 'center',
                sortable: false,
                align: 'center',
                renderCell: ({ row }) => {
                    let donacion = 0;
                    for (const envio of row?.envios || row?.enviosPanama) {
                        donacion += envio.donacion_total;
                    }
                    return pais === 'panama'
                        ? formatterPTY.format(donacion)
                        : formatterCOP.format(donacion);
                },
            },
        ];

        // Quito todos las donaciones si seleccionaron publicidad
        if (division.id === 1) {
            columns = columns.filter(
                (column) => !column.field.includes('donacion_'),
            );
        }

        switch (reporteType) {
            case 'colocacion_semanal':
                let res;
                if (tipo && tipo?.nombre === 'Promotor') {
                    res = await sendRequest(
                        'get',
                        `${URL}/${pais}/envio/colocacion/semanal?campana=${
                            campana.id
                        }&semana=${dayjs(fecha).week()}&division=${
                            division.id
                        }`,
                    );
                    setColumns([
                        {
                            field: 'codigo',
                            headerName: 'Código',
                            flex: 'auto',
                            headerClassName: 'header',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                        },
                        {
                            field: 'promotor',
                            headerName: 'Promotor',
                            flex: 0.5,
                            headerClassName: 'header',
                            headerAlign: 'center',
                            align: 'center',
                            sortable: false,
                            renderCell: ({ row }) =>
                                `${row.nombres} ${row.apellidos}`,
                        },
                        ...columns,
                    ]);
                }
                if (tipo && tipo?.nombre === 'Campaña') {
                    res = await sendRequest(
                        'get',
                        `${URL}/${pais}/campana/colocacion-semanal?semana=${dayjs(
                            fecha,
                        ).week()}&division=${division.id}`,
                    );
                    setColumns([
                        {
                            field: 'campana',
                            headerName: 'Nombre Campaña',
                            flex: 0.8,
                            headerClassName: 'header',
                            aling: 'center',
                            sortable: false,
                            renderCell: ({ row }) => row?.nombre,
                        },
                        ...columns,
                    ]);
                }
                handleClose();
                setCampanaSelected(campana);
                setLoading(false);
                setReporteDataSemanal(res?.data || []);
                calculaTotales(res?.data || []);
                setReporteDataDiario(null);
                break;
            case 'pre-reporte_diario':
                const resDiario = await sendRequest(
                    'get',
                    `${URL}/${pais}/envio/colocacion/diaria?division=${
                        division?.id
                    }&fecha=${dayjs(fecha).format('YYYY-MM-DD')}`,
                );
                setFecha(fecha);
                setReporteDataDiario(resDiario.data);
                setReporteDataSemanal(null);
                handleClose();
                setLoading(false);
                break;
            default:
                break;
        }
    };

    const calculaTotales = (data) => {
        let totales = {
            lunes: {
                cantidad: 0,
                donacion: 0,
            },
            martes: {
                cantidad: 0,
                donacion: 0,
            },
            miercoles: {
                cantidad: 0,
                donacion: 0,
            },
            jueves: {
                cantidad: 0,
                donacion: 0,
            },
            viernes: {
                cantidad: 0,
                donacion: 0,
            },
            sabado: {
                cantidad: 0,
                donacion: 0,
            },
            domingo: {
                cantidad: 0,
                donacion: 0,
            },
            total_semana: {
                cantidad: 0,
                donacion: 0,
            },
        };
        for (const row of data) {
            for (const envio of row.envios || row.enviosPanama) {
                switch (dayjs(envio.created_at).day()) {
                    case 1:
                        totales.lunes.cantidad += envio.cantidad;
                        totales.lunes.donacion += envio.donacion_total;
                        break;
                    case 2:
                        totales.martes.cantidad += envio.cantidad;
                        totales.martes.donacion += envio.donacion_total;
                        break;
                    case 3:
                        totales.miercoles.cantidad += envio.cantidad;
                        totales.miercoles.donacion += envio.donacion_total;
                        break;
                    case 4:
                        totales.jueves.cantidad += envio.cantidad;
                        totales.jueves.donacion += envio.donacion_total;
                        break;
                    case 5:
                        totales.viernes.cantidad += envio.cantidad;
                        totales.viernes.donacion += envio.donacion_total;
                        break;
                    case 6:
                        totales.sabado.cantidad += envio.cantidad;
                        totales.sabado.donacion += envio.donacion_total;
                        break;
                    default:
                        totales.domingo.cantidad += envio.cantidad;
                        totales.domingo.donacion += envio.donacion_total;
                        break;
                }
            }
        }
        totales.total_semana.cantidad =
            totales.lunes.cantidad +
            totales.martes.cantidad +
            totales.miercoles.cantidad +
            totales.jueves.cantidad +
            totales.viernes.cantidad +
            totales.sabado.cantidad +
            totales.domingo.cantidad;

        totales.total_semana.donacion =
            totales.lunes.donacion +
            totales.martes.donacion +
            totales.miercoles.donacion +
            totales.jueves.donacion +
            totales.viernes.donacion +
            totales.sabado.donacion +
            totales.domingo.donacion;

        setTotalesFooter({
            ...totales,
        });
    };

    const columnGrouping = [
        {
            groupId: 'first_day',
            headerName: `${weekDaysName[0]}`,
            children: [{ field: 'first_day' }, { field: 'donacion_first_day' }],
        },
        {
            groupId: 'second_day',
            headerName: `${weekDaysName[1]}`,
            children: [
                { field: 'second_day' },
                { field: 'donacion_second_day' },
            ],
        },
        {
            groupId: 'third_day',
            headerName: `${weekDaysName[2]}`,
            children: [{ field: 'third_day' }, { field: 'donacion_third_day' }],
        },
        {
            groupId: 'fourth_day',
            headerName: `${weekDaysName[3]}`,
            children: [
                { field: 'fourth_day' },
                { field: 'donacion_fourth_day' },
            ],
        },
        {
            groupId: 'fifth_day',
            headerName: `${weekDaysName[4]}`,
            children: [{ field: 'fifth_day' }, { field: 'donacion_fifth_day' }],
        },
        {
            groupId: 'sixth_day',
            headerName: `${weekDaysName[5]}`,
            children: [{ field: 'sixth_day' }, { field: 'donacion_sixth_day' }],
        },
        {
            groupId: 'seventh_day',
            headerName: `${weekDaysName[6]}`,
            children: [
                { field: 'seventh_day' },
                { field: 'donacion_seventh_day' },
            ],
        },
        {
            groupId: 'totales',
            headerName: '',
            children: [
                { field: 'total_semana' },
                { field: 'donacion_total_semana' },
            ],
        },
    ];

    return (
        <>
            <Grid container pb={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} sm={2} mt={5} mx={5}>
                        <Button
                            variant="contained"
                            fullWidth
                            style={{ textTransform: 'none' }}
                            color={
                                isButtonSelected.diario
                                    ? 'publicidad'
                                    : 'primary'
                            }
                            onClick={handlePrereporteDiario}
                        >
                            Pre-reporte Diario
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={2} mt={5} mx={5}>
                        <Button
                            variant="contained"
                            fullWidth
                            color={
                                isButtonSelected.semanal
                                    ? 'publicidad'
                                    : 'primary'
                            }
                            style={{ textTransform: 'none' }}
                            onClick={handleColocacionSemanal}
                        >
                            Cierre Colocación Semanal
                        </Button>
                    </Grid>
                </Grid>
                {loading && (
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        pt={10}
                    >
                        <CircularProgress />
                    </Grid>
                )}
                {(reporteDataSemanal?.length === 0 ||
                    (reporteDataDiario?.f2f?.items.length === 0 &&
                        reporteDataDiario?.tmk?.items.length === 0 &&
                        reporteDataDiario?.tmk_f2f?.items.length === 0)) && (
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        pt={3}
                    >
                        <Grid item xs={12} fontSize={80}>
                            <ReportGmailerrorred
                                color="primary"
                                fontSize="xl"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h4">
                                No se encontraron resultados de la busqueda
                            </Typography>
                        </Grid>
                    </Grid>
                )}
                {reporteDataSemanal?.length > 0 && (
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={12} mt={5}>
                            <Typography variant="h4" color="primary">
                                Colocación Semanal Por {tipoSelected?.nombre}{' '}
                                {campanaSelected
                                    ? ` - ${campanaSelected?.nombre}`
                                    : ''}{' '}
                                - {divisionSelected?.nombre}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="h5" color="primary">
                                Semana {dayjs(fecha).week()}
                            </Typography>
                            <Typography variant="h5" color="primary">
                                {weekMonthsName[0]} - {weekMonthsName[6]}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid conatiner>
                                <Grid item xs={12} mt={5}>
                                    <DataGrid
                                        apiRef={dataGridRef}
                                        experimentalFeatures={{
                                            columnGrouping: true,
                                        }}
                                        localeText={
                                            esES.components.MuiDataGrid
                                                .defaultProps.localeText
                                        }
                                        disableColumnSelector
                                        disableDensitySelector
                                        disableColumnFilter
                                        disableColumnMenu
                                        disableRowSelectionOnClick
                                        hideFooterPagination
                                        columns={columns}
                                        rows={reporteDataSemanal}
                                        loading={loading}
                                        slots={{
                                            footer: DataGridTotalFooterColocacion,
                                        }}
                                        slotProps={{
                                            footer: {
                                                ...totalesFooter,
                                                isFundraising:
                                                    divisionSelected.nombre ===
                                                    'Fundraising',
                                                tipoCampaña:
                                                    tipoSelected?.nombre ===
                                                    'Campaña',
                                                totalSize:
                                                    tipoSelected?.nombre ===
                                                        'Campaña' &&
                                                    divisionSelected.nombre ===
                                                        'Fundraising'
                                                        ? 1.09
                                                        : tipoSelected?.nombre ===
                                                              'Campaña' &&
                                                          divisionSelected.nombre !==
                                                              'Fundraising'
                                                        ? 2
                                                        : tipoSelected?.nombre ===
                                                              'Promotor' &&
                                                          divisionSelected.nombre !==
                                                              'Fundraising'
                                                        ? 2
                                                        : 1.45,
                                            },
                                        }}
                                        getRowHeight={() => 'auto'}
                                        sx={[
                                            DataGridStyle,
                                            {
                                                '& .css-yrdy0g-MuiDataGrid-columnHeaderRow':
                                                    {
                                                        backgroundColor:
                                                            'primary.main',
                                                    },
                                                '& .MuiDataGrid-columnHeaderTitleContainer':
                                                    {
                                                        justifyContent:
                                                            'center',
                                                        alignItems: 'center',
                                                        whiteSpace: 'normal',
                                                        wordWrap: 'normal',
                                                    },
                                            },
                                        ]}
                                        columnGroupingModel={
                                            divisionSelected.id === 2
                                                ? columnGrouping
                                                : []
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
                {reporteDataDiario &&
                    (reporteDataDiario?.f2f?.items.length !== 0 ||
                        reporteDataDiario?.tmk?.items.length !== 0 ||
                        reporteDataDiario?.tmk_f2f?.items.length !== 0) && (
                        <PreReporteDiario
                            pais={pais}
                            data={reporteDataDiario}
                            divisionSelected={divisionSelected}
                            fechaSelected={fecha}
                        />
                    )}
            </Grid>
            <Modal open={open} onClose={handleClose}>
                <>
                    {openPreReporteColocacion && (
                        <ModalColocacion
                            URL={URL}
                            pais={pais}
                            divisiones={divisiones}
                            handleClose={handleClose}
                            handleContinuar={handleContinuar}
                            fecha={fecha}
                            setFecha={setFecha}
                            hoveredDay={hoveredDay}
                            setHoveredDay={setHoveredDay}
                        />
                    )}
                    {openPreReporteDiario && (
                        <ModalDiario
                            URL={URL}
                            pais={pais}
                            divisiones={divisiones}
                            handleClose={handleClose}
                            handleContinuar={handleContinuar}
                            fecha={fecha}
                            setFecha={setFecha}
                        />
                    )}
                </>
            </Modal>
        </>
    );
};

export default PreReportes;
